import { baseUrl, Get, Post } from '.';
import { AffiliateUserCredentials } from '../config/helpers/local-storage-helper';

export const Signup = async (payload) => {
  try {
    return await Post(`${baseUrl}/affiliate-users/register`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const Login = async (payload) => {
  try {
    return await Post(`${baseUrl}/affiliate-users/login`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const VerifyAccount = async (payload) => {
  try {
    return await Post(`${baseUrl}/affiliate-users/verifyEmail`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const VerificationCode = async (payload) => {
  try {
    return await Post(`${baseUrl}/affiliate-users/verificationCode`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const UpdatePassword = async (payload) => {
  try {
    return await Post(`${baseUrl}/affiliate-users/updatePassword`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ResetPassword = async (payload) => {
  try {
    return await Post(`${baseUrl}/affiliate-users/updatePassword`, payload);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const UpdateProfile = async (payload) => {
  try {
    let { Authorization } = AffiliateUserCredentials();
    console.log('Authorization: ', Authorization);
    return await Post(
      `${baseUrl}/affiliate-users/update-profile`,
      payload,
      Authorization
    );
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Get referred users for affiliate dashboard
export const getReferredUsers = async () => {
  try {
    let { Authorization } = AffiliateUserCredentials();
    const response = await Get(
      `${baseUrl}/affiliate-users/referred-users`,
      Authorization
    );
    return response;
  } catch (error) {
    console.error('Error fetching referred users:', error);
    throw error;
  }
};

// Get user activities for affiliate dashboard
export const getUserActivities = async (userId) => {
  try {
    const response = await Get(`${baseUrl}/user-activities/${userId}`);
    return response;
  } catch (error) {
    console.error('Error fetching user activities:', error);
    throw error;
  }
};

// Get affiliate dashboard stats
export const getAffiliateStats = async () => {
  try {
    let { Authorization } = AffiliateUserCredentials();
    const response = await Get(
      `${baseUrl}/affiliate-users/dashboard-stats`,
      Authorization
    );
    return response;
  } catch (error) {
    console.error('Error fetching affiliate stats:', error);
    throw error;
  }
};
